import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingCart, Clock, CheckCircle2, IndianRupee, Package, TrendingUp, Loader2, AlertTriangle } from "lucide-react";
import api, { formatINR } from "@/lib/api";
import { AdminLayout } from "@/components/admin/AdminLayout";

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  const cards = stats ? [
    { label: "Total Orders", value: stats.total_orders, icon: ShoppingCart, color: "bg-amber-100 text-amber-800" },
    { label: "Pending Orders", value: stats.pending_orders, icon: Clock, color: "bg-orange-100 text-orange-800" },
    { label: "Paid Orders", value: stats.paid_orders, icon: CheckCircle2, color: "bg-green-100 text-green-800" },
    { label: "Completed", value: stats.completed_orders, icon: Package, color: "bg-blue-100 text-blue-800" },
    { label: "Available Products", value: stats.available_products, icon: TrendingUp, color: "bg-purple-100 text-purple-800" },
    { label: "Low-Stock Products", value: stats.low_stock_products, icon: AlertTriangle, color: "bg-red-100 text-red-800" },
    { label: "Revenue", value: formatINR(stats.revenue), icon: IndianRupee, color: "bg-yellow-100 text-yellow-900" },
  ] : [];

  return (
    <AdminLayout title="Dashboard">
      {!stats ? (
        <div className="flex justify-center py-24"><Loader2 size={36} className="animate-spin text-goldsoft" /></div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
            {cards.map((c) => (
              <div key={c.label} data-testid={`stat-${c.label.toLowerCase().replace(/[^a-z]/g, "-")}`} className="bg-white rounded-2xl border border-[#E5DFD3] p-6 flex items-center gap-5">
                <div className={`h-14 w-14 rounded-xl flex items-center justify-center ${c.color}`}><c.icon size={26} /></div>
                <div>
                  <p className="text-sm text-muted-foreground">{c.label}</p>
                  <p className="font-display text-3xl font-bold text-choco">{c.value}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8">
            <h2 className="font-display text-2xl font-bold text-choco mb-4">Quick Actions</h2>
            <div className="grid sm:grid-cols-3 gap-4">
              <button onClick={() => navigate("/admin/products")} className="bg-choco text-cream rounded-2xl p-6 text-left hover:bg-chocodark transition-colors min-h-[100px]">
                <Package size={26} className="text-gold" /><p className="font-semibold mt-3">Manage Products</p>
              </button>
              <button onClick={() => navigate("/admin/orders")} className="bg-choco text-cream rounded-2xl p-6 text-left hover:bg-chocodark transition-colors min-h-[100px]">
                <ShoppingCart size={26} className="text-gold" /><p className="font-semibold mt-3">View Orders</p>
              </button>
              <button onClick={() => navigate("/admin/settings")} className="bg-choco text-cream rounded-2xl p-6 text-left hover:bg-chocodark transition-colors min-h-[100px]">
                <TrendingUp size={26} className="text-gold" /><p className="font-semibold mt-3">Store Settings</p>
              </button>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  );
};

export default Dashboard;
